/**
 * Geometry of the fixed public site header.
 *
 * The header is `position: fixed; top: 0` with fluid padding and no height
 * token, so anything that needs to anchor content just below it has to measure
 * the live element instead of duplicating a magic number.
 */

/** Used while the header is absent or still without layout (first paint, SSR-less tests). */
export const FALLBACK_PUBLIC_HEADER_BOTTOM_PX = 88;

const HEADER_SELECTOR = "[data-public-site-header]";

/**
 * Distance from the top of the viewport to the header's bottom edge. Because the
 * header is fixed at `top: 0`, this doubles as its rendered height and stays
 * correct at any scroll position.
 */
export function getPublicHeaderBottom(): number {
  const header = document.querySelector<HTMLElement>(HEADER_SELECTOR);
  if (header === null) return FALLBACK_PUBLIC_HEADER_BOTTOM_PX;

  const { bottom } = header.getBoundingClientRect();
  return bottom > 0 ? bottom : FALLBACK_PUBLIC_HEADER_BOTTOM_PX;
}
